"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formatters = require("../utils/formatters");

var _i18n = require("../constants/i18n");

var CurrencyFormatter = function CurrencyFormatter(_ref) {
  var format = _ref.format,
      locale = _ref.locale,
      children = _ref.children;
  return (0, _isNil["default"])(children) ? '' : (0, _formatters.formatCurrency)(children, format, locale);
};

CurrencyFormatter.propTypes = {
  /** Options passed to `.toLocaleString()` */
  format: _propTypes["default"].object,

  /** Current locale */
  locale: _propTypes["default"].string,
  children: _propTypes["default"].number
};
CurrencyFormatter.defaultProps = {
  locale: _i18n.defaultLocale
};
var _default = CurrencyFormatter;
exports["default"] = _default;